import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const a=t("aruba",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="#418FDE" />
            <path
                d="M0 15.1664L24 15.1664V16.0552L0 16.0552L0 16.9441L24 16.9441V17.8329L0 17.8329L0 15.166L0 15.1664Z"
                fill="#FFD100" />
            <path
                d="M3.55707 5.38867L2.92837 7.42644L0.890625 8.05513L2.92837 8.68383L3.55707 10.7216L4.18576 8.68383L6.22351 8.05513L4.18576 7.42644L3.55707 5.38867Z"
                fill="white" />
            <path
                d="M3.5583 5.99357L4.0443 7.5698L5.62051 8.0558L4.0443 8.5418L3.5583 10.118L3.07231 8.5418L1.49609 8.05539L3.07231 7.56939L3.5583 5.99316V5.99357Z"
                fill="#EF3340" />
        </svg>
    `),d=t("aruba_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_92881)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 0.5L36.0003 0.5L36.0003 24.5L0 24.5L0 0.5Z"
                    fill="#418FDE" />
                <path
                    d="M0 16.4996L36.0003 16.4996V17.8329L0 17.8329L0 19.1661L36.0003 19.1661V20.4993L0 20.4993L0 16.499L0 16.4996Z"
                    fill="#FFD100" />
                <path
                    d="M6.90204 2.94434L5.95899 6.00098L2.90234 6.94403L5.95899 7.88708L6.90204 10.9437L7.84509 7.88708L10.9017 6.94403L7.84509 6.00098L6.90204 2.94434Z"
                    fill="white" />
                <path
                    d="M6.90194 3.8512L7.63093 6.21554L9.99528 6.94454L7.63093 7.67354L6.90194 10.0379L6.17294 7.67354L3.80859 6.94393L6.17294 6.21493L6.90194 3.85059V3.8512Z"
                    fill="#EF3340" />
            </g>
            <defs>
                <clipPath id="clip0_19477_92881">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{a as Aruba,d as ArubaRounded};
